<div class="page-transition">

  <!-- Banner -->
  <div class="relative h-[200px] sm:h-[300px] md:h-[400px] overflow-hidden">
    <img src="assets/images/static-banner/career.jpg" alt="Career" class="hidden md:block w-full h-full object-cover" />
    <img src="assets/images/static-banner/career-mobile.jpg" alt="Career" class="md:hidden w-full h-full object-cover" />
  </div>

  <!-- Title -->
  <section class="py-8 md:py-10 text-center bg-[#faf8f5]">
    <h1 class="text-xl md:text-2xl font-semibold text-gray-900 mb-2">{{ title }}</h1>
    <div class="flex items-center justify-center gap-2">
      <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#600b0b]/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
      <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
    </div>
  </section>

  <!-- Content -->
  <section class="py-8 md:py-12 bg-white">
    <div class="max-w-[900px] mx-auto px-4 md:px-6">

      <!-- Loading -->
      <div *ngIf="isLoading" class="text-center py-10">
        <div class="w-8 h-8 border-2 border-[#600b0b] border-t-transparent rounded-full animate-spin mx-auto"></div>
      </div>

      <!-- Dynamic content from API -->
      <div *ngIf="!isLoading && description" [innerHTML]="description" class="prose prose-sm max-w-none text-sm text-gray-600 leading-relaxed career-content"></div>

      <!-- Fallback static content -->
      <div *ngIf="!isLoading && !description" class="text-sm text-gray-600 leading-relaxed space-y-6">

        <div>
          <h2 class="text-lg font-bold text-gray-900 mb-2">About Working for MahattaArt</h2>
          <p>MahattaArt is made up of talented people who are original thinkers and who love a culture where innovation, creativity and results are valued. Since its inception in 2010, MahattaArt has grown to be a professional development and advancement for our employees. MahattaArt is an ambitious company, which presents a rare and exciting situation for our employees and job candidates.</p>
          <p class="mt-3"><strong>To know about openings :</strong><br/>
            Contact us at <a href="mailto:info@mahattaart.com" class="text-[#600b0b] font-medium hover:underline">info@mahattaart.com</a> or Call us at : +91-9599967091, +91-11-40367720
          </p>
        </div>

        <div>
          <h2 class="text-lg font-bold text-gray-900 mb-2">Discover your potential</h2>
          <p>As an innovative and growing company, MahattaArt consistently strives to remain competitive in attracting and retaining employees whose work-hard, play-hard attitude allows them to thrive in achieving both personal and professional goals. Our performance-based culture has been developed around this approach. You can also expect challenging, rewarding work, competitive salaries, great benefits, and tremendous opportunities for career growth.</p>
        </div>

        <div>
          <h2 class="text-lg font-bold text-gray-900 mb-2">Location</h2>
          <p>Delhi</p>
        </div>

      </div>
    </div>
  </section>
</div>
